// extracted by mini-css-extract-plugin
export const animationBackground = "index-module--animationBackground--TIBUk";
export const wrap = "index-module--wrap--1msyj";
export const title = "index-module--title--1_Kue";
export const abstract = "index-module--abstract--1wmFz";
export const abstract__divide = "index-module--abstract__divide--uARJS";
export const abstract__mail = "index-module--abstract__mail--1gpeG";